import { RevealWrapper } from '@/hooks/useRevealAnimation'

export default function AboutSection() {
  return (
    <section id="about" className="relative py-20 md:py-28 bg-background-50 overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text Content */}
          <RevealWrapper>
            <div className="reveal">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 inline-block" />
                About DAON
              </div>
              <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl text-primary-700 leading-snug mb-6">
                건강한 마음과<br />
                <span className="text-accent-600">행복한 삶</span>을 위해
              </h2>
              <p className="text-foreground-700 leading-relaxed mb-6 text-sm md:text-base">
                다온심리상담센터는 모든 이가 마음의 안정과 회복을 경험할 수 있는 공동체를
                지향합니다. 개인의 내면적 성장과 정서적 건강을 돕는 것을 최우선 가치로 삼으며,
                전문적이고 따뜻한 심리 지원 활동을 전개하고 있습니다.
              </p>
              <p className="text-foreground-600 leading-relaxed mb-8 text-sm md:text-base">
                우리는 공감과 존중을 바탕으로 한 관계 속에서 각자의 회복 과정을 함께하며,
                지역사회의 건강한 마음 문화를 함께 만들어가고자 합니다.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="border-l-2 border-primary-300 pl-4">
                  <p className="text-lg md:text-xl font-semibold text-accent-500 mb-1">회복</p>
                  <p className="text-xs md:text-sm text-foreground-600">마음의 안정과 균형</p>
                </div>
                <div className="border-l-2 border-primary-300 pl-4">
                  <p className="text-lg md:text-xl font-semibold text-accent-500 mb-1">성장</p>
                  <p className="text-xs md:text-sm text-foreground-600">지속적인 내면 발전</p>
                </div>
                <div className="border-l-2 border-primary-300 pl-4">
                  <p className="text-lg md:text-xl font-semibold text-accent-500 mb-1">공감</p>
                  <p className="text-xs md:text-sm text-foreground-600">진심 어린 마음의 연결</p>
                </div>
              </div>
            </div>
          </RevealWrapper>

          {/* Decorative Image */}
          <RevealWrapper>
            <div className="reveal reveal-delay-2 relative">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] md:aspect-[3/4]">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20serene%20interior%20with%20large%20window%20and%20natural%20light%2C%20green%20potted%20plants%2C%20comfortable%20chair%20and%20small%20wooden%20table%2C%20books%20stacked%20nearby%2C%20soft%20ivory%20and%20beige%20tones%2C%20peaceful%20atmosphere%20suggesting%20recovery%20and%20growth%2C%20editorial%20interior%20photography&width=700&height=900&seq=daon-about-image&orientation=portrait"
                  alt="편안한 상담 공간"
                  className="w-full h-full object-cover object-center"
                />
              </div>
              {/* Floating accent card */}
              <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-background-50 rounded-xl p-4 md:p-5 shadow-sm border border-background-200/60 max-w-[200px]">
                <p className="text-2xl md:text-3xl font-bold text-primary-600 mb-1">다온</p>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  마음의 회복과 성장을 위한 따뜻한 동행
                </p>
              </div>
            </div>
          </RevealWrapper>
        </div>
      </div>
    </section>
  )
}